/** @format */

import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
// Removed Tooltip import - info integrated or linked separately

function Stepper({ currentStep, steps = [], onStepClick }) {
	// Added default empty array

	// Determine max steps for calculations
	const maxSteps = steps.length;

	return (
		<nav aria-label="Progress Steps">
			<ol className="flex items-center w-full space-x-2 sm:space-x-4 mt-8 md:mt-4">
				{steps.map((step, index) => {
					const stepNumber = index + 1;
					const isActive = step.page === currentStep;
					const isCompleted = step.page < currentStep;

					return (
						<li
							key={step.page}
							className={`flex justify-center flex-1 ${
								index < maxSteps - 1
									? "relative after:content-[''] after:w-full after:h-0.5 after:border-b after:border-gray-200 after:inline-block after:absolute after:top-4 after:left-1/2 after:right-auto"
									: ""
							} ${isCompleted ? "after:border-primary" : ""} `}
						>
							<motion.button
								whileTap={{ scale: 0.95 }}
								onClick={() => onStepClick(step)}
								disabled={!isCompleted && !isActive} // Allow clicking completed or active steps
								className={`flex flex-col items-center text-center cursor-pointer disabled:cursor-default group focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 rounded-md px-1 py-0.5`}
								aria-current={isActive ? "step" : undefined}
							>
								{/* Step Bubble */}
								<div
									className={`z-10 relative flex justify-center items-center w-8 h-8 rounded-full text-sm font-semibold transition-colors duration-200
									${
										isActive
											? "bg-primary text-white ring-4 ring-white" // Active bubble
											: isCompleted
											? "bg-primary text-white hover:bg-primary/90" // Completed bubble
											: "bg-gray-200 text-gray-500 group-hover:bg-gray-300" // Upcoming bubble
									}
                                    `}
								>
									{isCompleted ? (
										<Check size={16} strokeWidth={3} />
									) : (
										step.page
									)}
								</div>

								{/* Step Name (Show below bubble) */}
								<span
									className={`mt-1.5 text-xs sm:text-sm transition-colors duration-200 whitespace-nowrap ${
										isActive
											? "text-primary font-semibold"
											: isCompleted
											? "text-primary group-hover:text-primary/80"
											: "text-gray-500 group-hover:text-gray-700"
									}`}
								>
									{step.name}
									{/* Tooltip could be added back here if needed */}
								</span>
							</motion.button>
						</li>
					);
				})}
			</ol>
		</nav>
	);
}

export default Stepper;
